import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import RootLayout from '@/layouts/RootLayout.vue';

/**
 * 抽卡-模块
 */
var drawCards = {
  path: '/drawCards',
  redirect: '/drawCards/index',
  component: RootLayout,
  children: [{
    path: '/drawCards/index',
    name: 'DrawCards',
    component: function component() {
      return import('views/drawCards/index.vue');
    },
    meta: {
      title: '抽卡'
    }
  }, {
    path: '/drawCards/detail',
    name: 'DrawCardsDetail',
    component: function component() {
      return import('views/drawCards/detail.vue');
    },
    meta: {
      title: '卡包图鉴'
    }
  }, {
    path: '/drawCards/recycle',
    name: 'DrawCardsRecycle',
    component: function component() {
      return import('views/drawCards/recycle.vue');
    },
    meta: {
      title: '回收卡片'
    }
  }, {
    path: '/drawCards/reward',
    name: 'DrawCardsReward',
    component: function component() {
      return import('views/drawCards/reward.vue');
    },
    meta: {
      title: '集齐奖励'
    }
  }, {
    path: '/drawCards/cardList',
    name: 'DrawCardsCardList',
    component: function component() {
      return import('views/drawCards/cardList.vue');
    },
    meta: {
      title: '我的卡包'
    }
  }, {
    path: '/drawCards/card',
    name: 'DrawCardsCard',
    component: function component() {
      return import('views/drawCards/card.vue');
    },
    meta: {
      title: '我的卡片'
    }
  }, {
    path: '/drawCards/cardDetail',
    name: 'DrawCardsCardDetail',
    component: function component() {
      return import('views/drawCards/cardDetail.vue');
    },
    meta: {
      title: '卡片详情'
    }
  }, {
    path: '/drawCards/moreList',
    name: 'DrawCardsMoreList',
    component: function component() {
      return import('views/drawCards/moreList.vue');
    },
    meta: {
      title: '更多'
    }
  }, {
    path: '/drawCards/order',
    name: 'DrawCardsOrder',
    component: function component() {
      return import('views/drawCards/order.vue');
    },
    meta: {
      title: '订单'
    }
  }, {
    path: '/drawCards/pay',
    name: 'DrawCardsPay',
    component: function component() {
      return import('views/drawCards/pay.vue');
    },
    meta: {
      title: '购买抽卡券'
    }
  }]
};
export default drawCards;